import { Action } from 'redux';

import { SetDataQuality } from '../../../bootstrap/redux/actions/AppActionTypes';
import { IContentInfo } from '../../../spacesPlatform/models/IContentInfo';

export interface SetDataQualityAction extends Action {
  item: IContentInfo;
}

export function setDataQualityAction(item: IContentInfo): SetDataQualityAction {
  return {
    type: SetDataQuality,
    item
  };
}
